import request from '@/http/request'

export const getWarehouseData = params => {
  return request.post(`${process.env.REACT_APP_RFID_API_URL}/rfid/v1/api/rfid-warehouse-config/page`, params)
}

export const getShiptoList = params => {
  return request.get(`${process.env.REACT_APP_RFID_API_URL}/rfid/v1/api/rfid-warehouse-config/shipto`, { params })
}
export const getDropDownList = () => {
  return request.get(`${process.env.REACT_APP_RFID_API_URL}/rfid/v1/api/rfid-warehouse-config/dropdown`)
}

export const saveWarehouseConfig = params => {
  return request.post(`${process.env.REACT_APP_RFID_API_URL}/rfid/v1/api/rfid-warehouse-config/default`, params)
}

export const warehouseExport = params => {
  return request.post(`${process.env.REACT_APP_RFID_API_URL}/rfid/v1/api/rfid-warehouse-config/export`, params, {
    responseType: 'blob',
    uploadOrDownload: true
  })
}
